export const textObjectHeight = 0.1;
export const markerObjectDimensions = 0.08;
export const offsetBetweenMarkerAndText = 0.02;